import { lazy } from "react";

const LoanApplicationForm = lazy(() => import("../Component/LoanApplication/LoanApplicationForm"));
const ShortLoanApplicationForm = lazy(() => import("../Component/LoanApplication/ShortLoanApplicationForm"));
const LoanApplicationList = lazy(() => import("../Component/LoanApplication/LoanApplicationList"));
const LoanDetails = lazy(() => import("../Component/LoanApplication/LoanDetails"));
const EditLoan = lazy(() => import("../Component/LoanApplication/EditLoan"));
const LoanApplicationDetailBanker = lazy(() => import("../Component/LoanApplication/LoanApplicationDetailBanker"));

const loanApplicationRoutes = [
  { path: "/loan-application-form/:uniqueLeadNumber/:leadId", element: <LoanApplicationForm />, protected: true },
  { path: "/short-loan-application-form/:uniqueLeadNumber/:leadId", element: <ShortLoanApplicationForm />, protected: true },
  { path: "/manage-loan-application", element: <LoanApplicationList />, protected: true },
  { path: "/loan-application-details/:id", element: <LoanDetails />, protected: true },
  { path: "/edit-loan-application/:id", element: <EditLoan />, protected: true },
  { path: "/loan-application-detail", element: <LoanApplicationDetailBanker />, protected: false },
];

export default loanApplicationRoutes;
